export function isInAppBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // Detect mobile devices
  const isMobile = /android|iphone|ipad|ipod/i.test(ua);

  const inAppBrowsers = [
    "FBAN", // Facebook
    "FBAV", // Facebook
    "FB_IAB", // Facebook in-app browser
    "Messenger", // Messenger
    "Instagram", // Instagram
    "Line", // LINE
    "Snapchat", // Snapchat
    "TikTok", // TikTok
    "LinkedInApp", // LinkedIn
    "Pinterest", // Pinterest
    "Twitter", // X / Twitter
  ];

  return isMobile && inAppBrowsers.some((browser) => ua.includes(browser));
}
